/** Budget lug'ati (en): qobiq, Overview, Expenses, Salaries, Bonuses */
export default {
  title: "Budget",
  subtitle: "{{scope}} · {{period}} · plan vs actual",
  month: "Month",
  editPlan: "Edit plan",
  tabs: { overview: "Overview", money: "Money", expenses: "Expenses", salaries: "Salaries", bonuses: "Bonuses", placements: "Carrier payments" },
  scope: { branch: "Branch", all: "All branches", yours: "Your branch" },
  cat: { salaries: "Salaries", expenses: "Expenses", bonuses: "Bonuses" },
  total: "Total",
  status: "Status",
  conflict: "Changed by {{who}}. Reloaded.",
  someoneElse: "someone else",
  plan: {
    saved: "Plan saved",
    saveFailed: "Could not save the plan.",
    title: "Plan · {{period}}",
    desc: "Monthly limits per branch. Actual spending is compared against these numbers.",
    save: "Save plan",
    branch: "Branch",
  },
  overview: {
    noPlan: "No plan set for {{month}}.",
    noPlanSub: "Actual spending is shown without limits.",
    noPlanOwner: "Use \"Edit plan\" above to set limits.",
    noPlanManager: "The owner sets the plan.",
    planKpi: "Plan · {{month}}",
    planSub_one: "{{count}} branch, 3 categories",
    planSub_other: "{{count}} branches, 3 categories",
    actual: "Actual",
    ofPlan: "{{pct}}% of plan",
    noPlanShort: "no plan",
    costPerHire: "Cost per hire",
    costSub_one: "{{count}} hire · salaries + expenses + bonuses",
    costSub_other: "{{count}} hires · salaries + expenses + bonuses",
    over: "Over budget",
    overBranches_one: "{{count}} branch",
    overBranches_other: "{{count}} branches",
    within: "All branches within plan",
    byCategory: "By category · {{month}}",
    pending: "pending",
    draft: "draft",
    alerts: "Alerts",
    noAlerts: "Nothing needs attention this month.",
    details: "Details →",
    review: "Review →",
    branches: "Branches · {{month}}",
    branchesSub: "Plan vs actual per branch. Cost per hire = total spend ÷ approved hires.",
    of: "of {{plan}} · {{pct}}%",
    noPlanBar: "· no plan",
    extra: "+ {{amount}} {{label}}",
    cols: { branch: "Branch", plan: "Plan", actual: "Actual", used: "Used", salaries: "Salaries", expenses: "Expenses", bonuses: "Bonuses", hires: "Hires", costPerHire: "Cost / hire" },
  },
  expenses: {
    archived: "Expense archived",
    archiveFailed: "Could not archive the expense.",
    add: "+ Add expense",
    categoryAll: "Category: all",
    statusAll: "Status: all",
    category: "Category",
    searchPlaceholder: "Search description",
    searchAria: "Search expenses",
    emptyFiltered: "No expenses match these filters",
    emptyMonth: "No expenses in {{month}}",
    emptyDesc: "Expenses entered by the branch manager go to the owner for approval.",
    cols: { date: "Date", category: "Category", description: "Description", branch: "Branch", amount: "Amount", submittedBy: "Submitted by", receipt: "Receipt", status: "Status", actions: "Reason / actions" },
    receipt: "Receipt",
    reason: "Reason: {{reason}}",
    notSpecified: "not specified",
    by: "by {{name}}",
    totalLabel: "Total (approved + pending):",
    rejectedSum: " · rejected {{amount}}",
    paginationLabel: "expenses",
    archiveTitle: "Archive expense?",
    archiveBody: "Nothing is deleted: the expense is hidden from lists and stays in the audit log.",
    archiveBodyRequest: " Its approval request is left as is.",
    summary: { plan: "{{month}} plan {{plan}}", notSet: "not set", spent: "· Spent {{amount}}", waiting: "Waiting for approval · {{amount}}" },
    modal: {
      tooLarge: "File is larger than {{mb}} MB.",
      dateRequired: "Date is required.",
      chooseCategory: "Choose a category.",
      positiveAmount: "Enter a positive amount.",
      chooseBranch: "Choose a branch.",
      receiptRequired: "Receipt is required.",
      updated: "Expense updated",
      submitted: "Submitted for approval",
      submittedSub: "The owner will see it in Approvals.",
      added: "Expense added",
      saveFailed: "Could not save the expense.",
      editTitle: "Edit expense",
      addTitle: "Add expense",
      submit: "Submit for approval",
      date: "Date", category: "Category", amount: "Amount", currency: "Currency", branch: "Branch", description: "Description", receipt: "Receipt",
      choose: "Choose…",
      noConversion: "Shown as entered; no conversion",
      descPlaceholder: "Facebook ads: driver leads (Oct 1-6)",
      keepReceipt: "Leave empty to keep the current receipt.",
      dropHere: "Drop a receipt here or",
      browse: "browse",
      fileTypes: "JPG, PNG or PDF, up to {{mb}} MB",
      removeFile: "Remove file",
      current: "Current: {{name}}",
      goesToOwner: "The expense goes to the owner for approval. Until then it is shown as Pending.",
    },
  },
  salaries: {
    saved: "Salaries saved",
    savedSub_one: "{{count}} row · {{month}}",
    savedSub_other: "{{count}} rows · {{month}}",
    saveFailed: "Could not save salaries.",
    markedPaid: "Marked as paid · {{name}}",
    markedUnpaid: "Marked as unpaid · {{name}}",
    updateFailed: "Could not update.",
    markedCount: "Marked {{count}} as paid",
    subtitle: "{{scope}} · salaries · {{month}}",
    markSelected: "Mark selected as paid",
    roleAll: "Role: all",
    role: "Role",
    paid: "Paid",
    paidAll: "Paid: all",
    notPaid: "Not paid",
    visibility: "Visible to the owner and your branch manager only",
    empty: "No employees match these filters",
    cols: { employee: "Employee", role: "Role", branch: "Branch", amount: "Monthly salary", paid: "Paid", paidDate: "Paid date", note: "Note" },
    selectAllUnpaid: "Select all unpaid",
    select: "Select {{name}}",
    lastMonth: "{{amount}} (last month)",
    salaryAria: "{{name}} salary",
    enterFirst: "Enter and save the amount first",
    ownerSets: "The owner sets this salary",
    ownerOnlyUnpaid: "Only the owner can mark as unpaid",
    bankTransfer: "Bank transfer",
    totalRow_one: "Total · {{count}} employee · paid {{paid}} / {{count}}",
    totalRow_other: "Total · {{count}} employees · paid {{paid}} / {{count}}",
    note: "The system only records the amount; money is paid via bank. Paid rows are locked.",
    unsaved_one: "{{count}} unsaved change",
    unsaved_other: "{{count}} unsaved changes",
    discard: "Discard",
    save: "Save salaries",
  },
  bonuses: {
    supplement: "Extra",
    calculated: "Calculated for {{month}}",
    calculatedSub: "{{count}} recruiters · approved and paid bonuses were kept",
    calculatedExtra: "Extra bonuses: {{count}} (hires approved later)",
    calcFailed: "Could not calculate.",
    approved_one: "Approved {{count}} bonus",
    approved_other: "Approved {{count}} bonuses",
    approvedSub: "Recruiters were notified.",
    approveFailed: "Could not approve.",
    markedCount: "Marked {{count}} as paid",
    updateFailed: "Could not update.",
    subtitle: "{{scope}} · recruiter bonuses · {{month}}",
    markPaid: "Mark as paid ({{count}})",
    calculate: "Calculate for {{month}}",
    approveAll: "Approve all ({{count}})",
    rule: "Rule: {{name}}",
    ruleBase: "· {{perHire}} per hire + {{per30}} per hire that stayed 30 days",
    rule60: " + {{amount}} for 60 days",
    rule90: " + {{amount}} for 90 days",
    editInAdmin: "Edit in Admin → Settings",
    statusAll: "Status: all",
    withBonusOnly: "Show: with bonus only",
    summary: "{{count}} recruiters · {{draft}} draft · {{approved}} approved · {{paid}} paid",
    emptyMonth: "No bonuses calculated for {{month}}",
    emptyDesc: "Bonuses are calculated from approved hires and retention checks in the status history.",
    emptyFiltered: "No bonuses match these filters",
    cols: { recruiter: "Recruiter", hires: "Hires", stayed: "Stayed 30 / 60 / 90 d", rule: "Rule", calculated: "Calculated", adjustment: "Adjustment", total: "Total", status: "Status" },
    selectApproved: "Select approved",
    select: "Select {{name}}",
    totalRow_one: "Total · {{count}} recruiter",
    totalRow_other: "Total · {{count}} recruiters",
    approveTitle_one: "Approve {{count}} bonus · {{month}}",
    approveTitle_other: "Approve {{count}} bonuses · {{month}}",
    approveDesc: "Approved bonuses are final: they count in the budget and recruiters see the amount on their dashboard.",
    approveSum: "Approve {{sum}}",
    hiresShort: "· {{count}} hires",
    adjSaved: "Adjustment saved · {{name}}",
    saveFailed: "Could not save.",
    adjustment: "Adjustment",
    adjustmentNote: "Adjustment note",
    notePlaceholder: "Note",
    hide: "Hide",
    details: "Details",
    d: {
      hiresIn: "Hires in {{month}} · {{count}} × {{per}} = {{sum}}",
      hiredOn: "• {{driver}} · hired {{date}}",
      start: " · start {{date}}",
      noHires: "No approved hires",
      stayed30: "Stayed 30 days · {{count}} × {{per}} = {{sum}}",
      d60: " · 60 d",
      d90: " · 90 d",
      noneYet: "None yet",
      result: "Result",
      calculated: "• Calculated: {{amount}}",
      adjustment: "• Adjustment: {{amount}}",
      total: "• Total: {{amount}}",
      status: "• Status: {{status}}",
      by: " · by {{name}}",
      paid: " · paid {{date}}",
    },
  },
  placements: {
    subtitle: "{{scope}} · money carriers pay for hired drivers",
    rule: "Due {{days}} days after the driver starts (Settings)",
    status: "Payment status",
    search: "Search driver or carrier",
    unit: "placements",
    empty: "Nothing here",
    emptyDesc: "Placements appear when a driver is hired.",
    state: { all: "All statuses", open: "Open: waiting and overdue", overdue: "Overdue", due: "Waiting (not due yet)", paid: "Paid", partial: "Partially paid", not_paid: "Not paid" },
    kpi: {
      overdue: "Overdue", overdueSub: "due date passed, not paid",
      due: "Waiting", dueSub: "not due yet", expected: "expected {{amount}}",
      paid: "Paid", partial_one: "{{count}} partially", partial_other: "{{count}} partially",
      notPaid: "Not paid",
      approvalPending: "Awaiting approval", approvalPendingSub: "hire not approved yet",
    },
    cols: { driver: "Driver", recruiter: "Recruiter", branch: "Branch", carrier: "Carrier", started: "Started", due: "Due", amount: "Amount", status: "Status", note: "Note" },
    modalTitle: "Carrier payment",
    started: "started {{date}}",
    dueOn: "due {{date}}",
    amount: "Amount ($)",
    amountHint: "Leave empty if unknown",
    paidOn: "Paid on",
    note: "Note",
    notePlaceholder: "e.g. replacement for another driver",
    filters: { carrier: "All carriers", recruiter: "All recruiters", approval: "Hire approval: any", approvalYes: "Hire approved", approvalNo: "Awaiting approval", period: "Hired in: any month" },
    emptyFiltered: "Nothing matches these filters.",
    addPayment: "Payment",
    recordPayment: "Record payment",
    receivedLine: "received {{received}}",
    remainingLine: "remaining {{remaining}}",
    legacy: "status from import · no payment recorded",
    remainingBox: "Received {{received}} of {{total}} · remaining {{remaining}}",
    paymentTitle: "Money received from the carrier",
    paymentAmount: "Amount received ($)",
    paymentAmountRequired: "Enter the amount.",
    paymentAccountRequired: "Choose the account the money came to.",
    paymentDate: "Date",
    paymentTime: "Time",
    paymentNotePlaceholder: "e.g. wire reference",
    paymentSaved: "{{amount}} recorded · {{name}}",
    convertedHint: "The account is in {{currency}}: converted at the rate of the payment day.",
    editTitle: "Fee terms",
    dueDate: "Due date",
    editReceivedNote: "Already received {{received}}: the status is recalculated from the payments.",
    writeOffTitle: "Mark {{name}} as not paid?",
    writeOffDesc: "Use this when the carrier will not pay. You can reopen it later.",
    writeOff: "Mark as not paid",
    reopen: "Reopen",
    voidTitle: "Cancel this payment?",
    voidDesc: "{{amount}} → {{account}} is removed from the ledger (kept in the audit log); the status is recalculated.",
    void: "Cancel payment",
    voided: "Payment cancelled · {{name}}",
    saved: "Payment saved · {{name}}",
  },
  money: {
    income: "Income",
    expense: "Expense",
    transfer: "Transfer",
    totalBalance: "Money on accounts",
    totalHint: "All accounts in USD at today's rate",
    inCurrency: "In {{currency}}",
    rate: "Exchange rate",
    rateValue: "1 USD = {{rate}} UZS",
    noRate: "No rate yet",
    rateCbu: "Central Bank · {{date}}",
    rateManual: "Set manually · {{date}}",
    rateTitle: "USD/UZS exchange rate",
    rateDesc: "The Central Bank rate is loaded automatically every day. A rate you set manually for a day is not overwritten.",
    rateSaved: "Exchange rate saved",
    company: "Company",
    newAccount: "New account",
    archived: {
      link: "Archived accounts ({{count}})",
      title: "Archived accounts",
      desc: "They are not in the list or the totals. Restore an account to use it again or to cancel a payment made from it.",
      restore: "Restore",
      restored: "{{name}} is back in the list",
    },
    editAccount: "Edit account",
    accountDesc: "Cash box, card or bank account. Only the last 4 digits of a card are stored.",
    accountCreated: "Account opened · {{name}}",
    accountSaved: "Account saved",
    deleteTitle: "Delete {{name}}?",
    deleteDesc: "Balance: {{balance}}. The account leaves the list and the totals; its entries stay in the ledger and the audit log, and linked payments stay paid.",
    deleted: "Deleted · {{name}}",
    reconcileTitle: "Reconcile {{name}}",
    reconcileDesc: "Enter the real balance of the card or cash. The difference is recorded as one adjustment; the history stays.",
    reconcileIn: "An income adjustment of {{amount}} will be recorded",
    reconcileOut: "An expense adjustment of {{amount}} will be recorded",
    reconcileSame: "The balance already matches.",
    reconciled: "{{account}} reconciled to {{amount}}",
    noAccountsTitle: "No accounts yet",
    noAccountsManager: "The owner opens accounts and can attach them to your branch.",
    filterByAccount: "Show this account's movements",
    accountKinds: { cash: "Cash", card: "Card", bank: "Bank account" },
    kinds: { fee: "Carrier fee", income: "Income", expense: "Expense", salary: "Salary", bonus: "Bonus", transfer: "Transfer", adjustment: "Correction" },
    flow: { all: "All", in: "Money in", out: "Money out", transfer: "Transfers" },
    ledger: "Money in and out · {{month}}",
    ledgerSub: "Every movement on the accounts. Right-click a row to edit or cancel it.",
    ledgerFor: "Account: {{account}}",
    allAccounts: "All accounts",
    searchPh: "Search description or who",
    movements: "movements",
    emptyTitle: "No movements this month",
    emptyDesc: "Record income, expenses and transfers with the buttons above. Paid salaries, bonuses and expenses appear here automatically.",
    emptyNoAccounts: "Open an account first.",
    toAcc: "to {{account}}",
    fromAcc: "from {{account}}",
    col: { date: "Date", what: "What", account: "Account", type: "Type", amount: "Amount", usd: "In USD", balance: "Balance" },
    moveTitle: { income: "Money in", expense: "Expense", adjustment: "Correct the balance" },
    moveDesc: {
      income: "Money received that is not a carrier fee: investment, refund and so on. Carrier fees are recorded in Carrier payments.",
      expense: "Recorded as an approved expense and paid from the account in one step.",
      adjustment: "Only when the real balance differs from the one shown (for example after counting the cash).",
    },
    saved: {
      income: "{{amount}} received to {{account}}",
      expense: "{{amount}} paid from {{account}}",
      adjustment: "Balance of {{account}} corrected",
    },
    editMove: "Edit movement",
    editLinkedHint: "Amount and date of a linked payment cannot be changed: cancel it and record it again.",
    transferTitle: "Transfer between accounts",
    transferDesc: "For example cash to the card or USD to UZS. Both sides are recorded.",
    transferDo: "Transfer",
    transferred: "Transferred: {{from}} → {{to}}",
    voidTitle: "Cancel this movement?",
    voidDesc: "{{amount}} on {{account}} will no longer count in the balance.",
    voidLinked: "The salary or bonus will be marked unpaid again.",
    voidTransfer: "Both sides of the transfer are cancelled.",
    voided: "Movement cancelled",
    menu: {
      income: "Money in",
      expense: "Expense",
      transfer: "Transfer",
      edit: "Edit account",
      reconcile: "Reconcile balance",
      delete: "Delete",
      openLinked: "Open the record",
      openDriver: "Open driver",
      editMove: "Edit",
      void: "Cancel movement",
    },
    f: {
      name: "Name",
      namePh: "e.g. Office cash, Kapitalbank Humo",
      kind: "Type",
      currency: "Currency",
      currencyLocked: "Cannot change after money movements",
      bank: "Bank / card",
      bankPh: "e.g. Kapitalbank Humo",
      last4: "Card: last 4 digits",
      last4Hint: "The full number is never stored",
      branch: "Branch",
      branchHint: "With a branch, its manager also sees and records this account. Without one, only the owner.",
      company: "Company (owner only)",
      opening: "Opening balance, {{currency}}",
      openingDate: "Balance as of",
      note: "Note",
      account: "Account",
      direction: "Direction",
      adjIn: "Add to the balance",
      adjOut: "Subtract from the balance",
      ledgerBalance: "Ledger balance",
      actualBalance: "Actual balance, {{currency}}",
      amount: "Amount, {{currency}}",
      date: "Date",
      time: "Time",
      category: "Category",
      chooseCategory: "Choose a category",
      noCategory: "No category",
      branchFromAccount: "Default: {{branch}} (the account's branch)",
      noBranch: "No branch",
      counterparty: "From whom",
      counterpartyPh: "e.g. owner, refund from a supplier",
      description: "Description",
      from: "From",
      to: "To",
      received: "Received, {{currency}}",
      receivedHint: "Suggested at 1 USD = {{rate}} UZS; change it if the bank rate differs",
      rate: "1 USD in UZS",
    },
  },
  commission: {
    label: "Commission, %",
    hint: "Optional. Filled in from the category; empty or 0 means no commission.",
    invalid: "Enter 0 to 99.99.",
    resultIn: "Commission {{fee}} · to the account {{net}}",
    resultOut: "Commission {{fee}} · from the account {{net}}",
    rowIn: "{{base}} − {{pct}}% commission",
    rowOut: "{{base}} + {{pct}}% commission",
  },
  pay: {
    paying: "To pay:",
    receiving: "To receive:",
    fromAccount: "Paid from",
    toAccount: "Received to",
    choose: "Choose an account",
    noAccounts: "No accounts yet: the owner opens them in Budget → Money.",
    noAccount: "No account (just mark as paid)",
    noAccountHint: "The money is not recorded in any account balance.",
    date: "Date",
    time: "Time",
    converted: "From the account: {{amount}} (1 USD = {{rate}} UZS; the exact rate of the payment day is used)",
    noRate: "There is no USD/UZS rate yet.",
    balanceAfter: "Balance: {{before}} → {{after}}",
    insufficient: "Insufficient balance: {{short}} short on this account.",
    markPaid: "Mark paid",
    pay: "Pay",
    salaryTitle_one: "Pay salary",
    salaryTitle_other: "Pay {{count}} salaries",
    bonusTitle_one: "Pay bonus",
    bonusTitle_other: "Pay {{count}} bonuses",
    expenseTitle: "Pay expense",
    expensePaid: "Expense paid",
    payExpense: "Pay",
    paidFrom: "Paid · {{account}}",
    feeAccountHint: "Choose where the money arrived to see it in the account balance",
    receivedNow: "Received now, USD",
    receivedHint: "Empty: the full payment amount",
  },
  cash: {
    onAccounts: "Money on accounts",
    noAccounts: "Open accounts in Money",
    in: "Money in · {{month}}",
    out: "Money out · {{month}}",
    net: "Net · {{month}}",
    netSub: "Money in minus money out (transfers excluded)",
    vsPrev: "{{pct}}% vs last month",
    noPrev: "nothing last month",
    missingRate: "Some UZS amounts have no rate yet",
    chartTitle: "Money in and out · 12 months",
    chartSub: "All accounts, in USD. Transfers between accounts are not counted.",
    chartEmpty: "No money movements yet. Open accounts in Budget → Money.",
    series: { in: "Money in", out: "Money out", net: "Net" },
    spendTitle: "Where the money went · {{month}}",
    spendEmpty: "No spending this month.",
    other: "Other",
    dueTitle: "To pay and to receive",
    nothingDue: "Everything approved is paid.",
    due: {
      expenses_one: "{{count}} approved expense",
      expenses_other: "{{count}} approved expenses",
      salaries_one: "{{count}} unpaid salary",
      salaries_other: "{{count}} unpaid salaries",
      bonuses_one: "{{count}} approved bonus",
      bonuses_other: "{{count}} approved bonuses",
    },
    pay: "Pay",
    open: "Open",
    payable: "We owe",
    receivable: "Owed to us",
    feesExpected_one: "{{count}} carrier payment expected",
    feesExpected_other: "{{count}} carrier payments expected",
    feesOverdue_one: "{{count}} overdue",
    feesOverdue_other: "{{count}} overdue",
    feesNoAmount_one: "{{count}} without an amount",
    feesNoAmount_other: "{{count}} without an amount",
  },
};
